import * as api from './base';

export const index = () => api.get({
	url: "solicit/index",
	undefined,
	loading: "加载中"
});

export const edit = (id) => api.get({
	url: `solicit/edit?id=${id}`,
	undefined,
	loading: "加载中"
});

export const essayList = (page) => api.get({
    url: "Solicit/List?page=" + page,
    loading: "加载中"
});

//提交投稿
export const solicitSubmit = (data) => api.post({
    url: "Solicit/Submit",
    data: data,
    loading: "正在提交"
});

